import {
  getExperimentForPath,
  getTreatmentCountForPath,
  isBinaryExperiment,
  isMultiVariateExperiment,
} from '../experiments/isMultiVariateExperiment';
import type { ExperimentConfig } from '../experiments/types';
import { STATIC_EXPERIMENT_MULTI_TREATMENTS } from '../experiments/variantConfig';
import type { SupportedExperimentVariants } from './types';

type StaticExperimentMultiTreatment = (typeof STATIC_EXPERIMENT_MULTI_TREATMENTS)[number];

export const isStaticExperiment = (experiments: ExperimentConfig[], experimentName: string) => {
  return experiments.some(experiment => experiment.name === experimentName);
};

/**
 * When just checking if a static experiment is active and don't care
 * if it is control or the variant(s)
 */
export function isStaticExperimentActive(
  experiments: ExperimentConfig[],
  experimentId: string,
  path: string,
) {
  return getExperimentForPath(experiments, path)?.name === experimentId;
}

export function isStaticExperimentEnabled(
  experiments: ExperimentConfig[],
  experimentId: string,
  path: string,
  experimentDecision: SupportedExperimentVariants,
) {
  if (!isStaticExperimentActive(experiments, experimentId, path)) {
    return false;
  }

  if (isMultiVariateExperiment(experiments, path)) {
    const activeTreatments = STATIC_EXPERIMENT_MULTI_TREATMENTS.slice(
      0,
      getTreatmentCountForPath(experiments, path),
    );
    return activeTreatments.includes(experimentDecision as StaticExperimentMultiTreatment);
  }

  if (isBinaryExperiment(experiments, path)) {
    return experimentDecision === 'treatment';
  }

  return false;
}
